/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AuthTokenResponse
 */
export interface AuthTokenResponse {
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  tokenType: string
  /**
   *
   * @type {number}
   * @memberof AuthTokenResponse
   */
  expiresIn: number
  /**
   * AccessToken
   * @type {string}
   * @memberof AuthTokenResponse
   */
  accessToken: string
  /**
   * RefreshToken
   * @type {string}
   * @memberof AuthTokenResponse
   */
  refreshToken: string
  /**
   *
   * @type {boolean}
   * @memberof AuthTokenResponse
   */
  mustChangePassword?: boolean
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  phone?: string
}

/**
 * Check if a given object implements the AuthTokenResponse interface.
 */
export function instanceOfAuthTokenResponse(
  value: object
): value is AuthTokenResponse {
  if (!('tokenType' in value) || value['tokenType'] === undefined) return false
  if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false
  if (!('accessToken' in value) || value['accessToken'] === undefined)
    return false
  if (!('refreshToken' in value) || value['refreshToken'] === undefined)
    return false
  return true
}

export function AuthTokenResponseFromJSON(json: any): AuthTokenResponse {
  return AuthTokenResponseFromJSONTyped(json, false)
}

export function AuthTokenResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AuthTokenResponse {
  if (json == null) {
    return json
  }
  return {
    tokenType: json['tokenType'],
    expiresIn: json['expiresIn'],
    accessToken: json['accessToken'],
    refreshToken: json['refreshToken'],
    mustChangePassword:
      json['mustChangePassword'] == null
        ? undefined
        : json['mustChangePassword'],
    phone: json['phone'] == null ? undefined : json['phone'],
  }
}

export function AuthTokenResponseToJSON(value?: AuthTokenResponse | null): any {
  if (value == null) {
    return value
  }
  return {
    tokenType: value['tokenType'],
    expiresIn: value['expiresIn'],
    accessToken: value['accessToken'],
    refreshToken: value['refreshToken'],
    mustChangePassword: value['mustChangePassword'],
    phone: value['phone'],
  }
}
